import React from "react";
import { Icon, PoweredByQgiv } from "@qgiv/core-react";
import { Button, Field, ProcessingButton } from "@qgiv/core-donor";
import "./EmailReminderExitIntent.scss";

/**
 * @param {object} props
 * @param {boolean} props.displayLoadingAnimation
 * @param {string} props.emailAddress
 * @param {boolean} props.error
 * @param {string} props.errorText
 * @param {Function} props.handleAcceptReminderClick
 * @param {Function} props.handleBlur
 * @param {Function} props.handleChange
 * @param {Function} props.handleDeclineReminderClick
 * @returns {React.ReactElement}
 */
const EmailReminderExitIntent = ({
    displayLoadingAnimation,
    emailAddress,
    error,
    errorText,
    handleAcceptReminderClick,
    handleBlur,
    handleChange,
    handleDeclineReminderClick,
}) => (
    <div className="email-reminder-exit-intent">
        <Icon
            className="email-reminder-exit-intent__icon"
            type="FontAwesome"
            glyph="bell-on"
        />
        <h2 className="-text--center -margin-top--15">
            Not ready to give yet?
        </h2>
        <p className="-text--center -margin-top--10">
            Share your email and we&apos;ll follow up with a friendly reminder.
        </p>
        <div className="-margin-top--30">
            <Field
                autoComplete="email"
                autoFocus
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={error}
                errorText={errorText}
                id="Reminder_Email"
                label="Email address"
                name="Reminder_Email"
                required
                type="email"
                value={emailAddress}
            />
        </div>
        <div className="email-reminder-exit-intent__button-container -margin-top--30">
            {displayLoadingAnimation ? (
                <ProcessingButton showBackground={false} scopeToModal />
            ) : (
                <Button onClick={handleAcceptReminderClick} type="button">
                    Send a reminder
                </Button>
            )}
            <Button
                btnStyle="secondary"
                onClick={handleDeclineReminderClick}
                type="button"
            >
                No, thanks
            </Button>
        </div>
        <PoweredByQgiv />
    </div>
);

export default EmailReminderExitIntent;
